<template>
  <layout-basic>
    <page-hero
      title="Internal Communications"
      lead="Share policies, updates and learning in one place."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="features" />
      </v-container>
    </section>

    <point-grid
      title="Keep everyone informed and aligned"
      :points="points"
      :columns="2"
      tint
    />

    <standard-cta
      title="Ready to simplify internal communications?"
      lead="Watch the 4-minute demo or experience IMPROVE and see how easy sharing updates can be."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'SolutionInternalComms',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Internal Communications | IMPROVE',
      description:
        'Share policies, updates and learning in one place so every employee stays aligned.',
      path: '/solutions/internal-communications',
    });
  },
  data() {
    return {
      points: [
        'Publish policies and procedures centrally',
        'Share company updates alongside learning',
        'Confirm employees have read key content',
        'Upload videos, documents and guides',
        'Reach teams wherever they work',
        'Reduce email clutter and missed messages',
      ],
    };
  },
};
</script>